import GS from '../../grafsync/grafsync';
import Help from '../../core/Help';
import ProjectLink from '../core/ProjectLink';
import SearchSelect from '../../core/SearchSelect';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import InAppBar from '../../core/InAppBar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import CancelButton from '../../core/CancelButton';
import PrimaryAddButton from '../../core/PrimaryAddButton';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import { globalStyles as styles } from '../../core/style/gstheme';
import { checkValidForDatatype, getGraphFromProject, getProjectFromGraph, computeConceptIcon } from '../../core/utils/utils';
import SchemeLink from '../core/SchemeLink';
import SearchLinkedData from '../../core/SearchLinkedData';

class FindRelatedConceptDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            tabValue: 0,
            text: "",
            projectOnly: false,
            offerExternal: false,
            externalDuplicate: false
        };
    }

    handleClickOpen = () => this.setState({ open: true });

    updateSearchText = (text) => this.setState({ text, externalDuplicate: false, offerExternal: false });

    computeSearch = (value, lang, projectIRI, skosXL) => {
        const projectOnly = this.state.tabValue !== 1 || !this.props.associatedProject || this.props.associatedProject.length === 0;
        const projectGraphs = projectOnly ?
            [getGraphFromProject(projectIRI)]
            :
            Array.isArray(this.props.associatedProject) ?
                this.props.associatedProject.map(ap => getGraphFromProject(ap))
                :
                [getGraphFromProject(this.props.associatedProject)];
        const search = this.props.matching ?
            {
                predicate: "http://www.w3.org/2004/02/skos/core#inScheme",
                exclude: this.props.schemeIRI.includes('#') ?
                    [this.props.schemeIRI, this.props.schemeIRI + "/"]
                    :
                    [this.props.schemeIRI, this.props.schemeIRI + "/", this.props.schemeIRI + "#"]
            }
            :
            {
                predicate: "http://www.w3.org/2004/02/skos/core#inScheme",
                value: this.props.schemeIRI
            };
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: "http://www.w3.org/2004/02/skos/core#Concept"
                },
                search,
                {
                    predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                    value: value,
                    isExactMatch: false
                }
            ],
            allowMissingResults: true,
            graph: projectGraphs,
            excludeByPath: [{
                predicate: "http://www.w3.org/2004/02/skos/core#broader",
                target: this.props.source
            },
            {
                predicate: "http://www.w3.org/2004/02/skos/core#narrower",
                target: this.props.source
            },
            {
                predicate: "http://www.w3.org/2004/02/skos/core#related",
                target: this.props.source
            }],
            exclude: this.props.exclude,
            pageSize: 20,
            entailment: skosXL ? ["propertyChain"] : [],
            language: lang,
            predicates: [
                "http://www.w3.org/2004/02/skos/core#prefLabel",
                "http://www.w3.org/2002/07/owl#deprecated",
                "https://grafsync.graphifi.com/schema/gs/iri",
                "https://grafsync.graphifi.com/schema/gs/status",
                "http://www.w3.org/2004/02/skos/core#inScheme"
            ]
        };
        return fullSearch;
    };

    includeConcept = (id) => {
        this.props.onIncludeConcept(id);
        this.exitFindConcept();
    };

    addExternal = () => this.includeConcept(this.state.externalIRI);

    exitFindConcept = () => this.setState({ open: false, externalDuplicate: false, text: "", tabValue: 0, offerExternal: false });

    declineExternal = () => this.setState({ text: "", offerExternal: false, externalDuplicate: false });

    offerExternal = (iri, valid = true) => {
        if (!valid || iri.includes("graphifi") || (this.props.components && this.props.components.includes(iri))) {
            this.setState({
                externalDuplicate: false,
                offerExternal: false
            });
        }
        else if (this.props.exclude.includes(iri)) {
            this.setState({
                externalDuplicate: true,
                offerExternal: false
            });
        }
        else {
            const isValid = checkValidForDatatype(iri, "http://www.w3.org/2001/XMLSchema#anyURI");
            this.setState({
                externalDuplicate: false,
                offerExternal: isValid,
                externalIRI: iri
            });
        }
    };

    changeTab = (tabValue) => this.setState({ tabValue, externalDuplicate: false, offerExternal: false });

    render() {

        const { classes, addTitle, viewLang, permitExternal, schemeIRI, linkedData, exclude, useWorkflow, associatedProject } = this.props;
        const { offerExternal, externalDuplicate, tabValue, text } = this.state;

        const defaultToSearch = (tabValue === 2 && (!linkedData || (linkedData && linkedData.length === 0)))
            || (tabValue === 1 && (!associatedProject || (associatedProject && associatedProject.length === 0)));

        const tabItems = [
            {
                icon: tabValue === 0 || defaultToSearch ? CheckCircleIcon : RadioButtonUncheckedIcon,
                label: "Current Project",
            },
            {
                icon: tabValue === 1 ? CheckCircleIcon : RadioButtonUncheckedIcon,
                disabled: associatedProject.length === 0,
                label: "Linked Taxonomy Projects",
            },
            {
                icon: tabValue === 2 ? CheckCircleIcon : RadioButtonUncheckedIcon,
                disabled: !linkedData || !linkedData.includes("DBpedia"),
                label: "DBpedia"
            },
            {
                icon: tabValue === 3 ? CheckCircleIcon : RadioButtonUncheckedIcon,
                disabled: !linkedData || !linkedData.includes("Wikidata"),
                label: "Wikidata"
            }
        ];

        return (
            <ProjectConsumer>
                {({ id: projectIRI, skosXL, defaultLang }) => (
                    <React.Fragment>
                        <AddButton dataTest="add-related-concept" onClick={() => this.handleClickOpen()} title="Add a relationship" />
                        <Dialog
                            data-test="find-related-concept-dialog"
                            fullWidth
                            maxWidth="lg"
                            classes={{
                                paper: classes.paper,
                                paperWidthLg: classes.largeDialog
                            }}
                            className={classes.dialog}
                            open={this.state.open}
                            onClose={this.exitFindConcept}
                            aria-labelledby="find-concept-dialog-title">
                            <DialogTitle disableTypography className={classes.mainHeading} id="find-concept-dialog-title">{addTitle || "Find a related concept"}</DialogTitle>
                            <DialogContent style={{ height: 400 }}>
                                <Help textRef="FIND_RESOURCE" />
                                {permitExternal &&
                                    <InAppBar
                                        tabValue={tabValue}
                                        background={false}
                                        onChangeTab={this.changeTab}
                                        tabItems={tabItems} />
                                }
                                {tabValue >= 2 && !defaultToSearch ?
                                    tabValue === 2 ?
                                        <div style={{ height: 350 }}>
                                            <SearchLinkedData
                                                exclude={exclude}
                                                key="dbpedia"
                                                mode="dbpedia"
                                                updateSearchText={this.updateSearchText}
                                                chosen={this.includeConcept}
                                                initialText={text} />
                                        </div>
                                        :
                                        <div style={{ height: 350 }}>
                                            <SearchLinkedData
                                                key="wikidata"
                                                mode="wikidata"
                                                exclude={exclude}
                                                updateSearchText={this.updateSearchText}
                                                chosen={this.includeConcept}
                                                initialText={text} />
                                        </div>
                                    :
                                    <div style={{ height: 350 }}>
                                        <SearchSelect
                                            dataTest="find-related-concept"
                                            key={tabValue + "-" + defaultToSearch}
                                            focus={true}
                                            exclude={exclude}
                                            updateSearchText={this.updateSearchText}
                                            sortByLength={true}
                                            allowIRIonNoResults={tabValue === 0}
                                            allowEmpty={false}
                                            initialText={text}
                                            maxLength={250}
                                            search={(value, lang) => this.computeSearch(value, lang, projectIRI, skosXL)}
                                            listSecondIcon={(result) => computeConceptIcon(result, useWorkflow)}
                                            listSelectionDisplay={(result, lang) => result.prefLabel && result.prefLabel[lang] ?
                                                Array.isArray(result.prefLabel[lang]) ?
                                                    result.prefLabel[lang][0]
                                                    :
                                                    result.prefLabel[lang]
                                                :
                                                ""}
                                            listDisplay={(result, lang) => {
                                                const text = result.prefLabel && result.prefLabel[lang] ?
                                                    Array.isArray(result.prefLabel[lang]) ?
                                                        result.prefLabel[lang].sort().join(" AND ")
                                                        :
                                                        result.prefLabel[lang]
                                                    :
                                                    result.id;
                                                const isGraphLocked = result.inNamedGraph && GS.isGraphLocked(result.inNamedGraph);
                                                const inMultipleGraphs = result.inNamedGraph && Array.isArray(result.inNamedGraph);
                                                const currentIRI = result.iri && result.iri.length > 0 ?
                                                    result.iri[result.iri.length - 1]
                                                    :
                                                    result.id;
                                                return <div>
                                                    <Typography
                                                        data-test="result-text"
                                                        lang={lang}
                                                        variant="body2">
                                                        <span style={{ wordBreak: 'break-word' }}>
                                                            <Tooltip
                                                                PopperProps={{
                                                                    "data-test": "result-tip"
                                                                }}
                                                                title={currentIRI}>
                                                                <span data-test="result-text-words">{text}</span>
                                                            </Tooltip>
                                                        </span>
                                                    </Typography>
                                                    {inMultipleGraphs &&
                                                        <Typography data-test="conflicting-iri" variant="caption">This IRI resource is conflicting as found in multiple proejcts.</Typography>
                                                    }
                                                    {result.inScheme && !result.inScheme.includes(schemeIRI) && !inMultipleGraphs &&
                                                        result.inScheme.map(scheme =>
                                                            <SchemeLink handleNotAvailable={true} key={scheme} id={scheme} graph={result.inNamedGraph} defaultLang={defaultLang} />
                                                        )}
                                                    {tabValue === 1 && !inMultipleGraphs &&
                                                        <ProjectLink
                                                            locked={isGraphLocked}
                                                            id={getProjectFromGraph(result.inNamedGraph)}
                                                            defaultLang={defaultLang}
                                                            graph={result.inNamedGraph}
                                                            key={result.id} />
                                                    }
                                                </div>;
                                            }}
                                            sortProp="prefLabel"
                                            errorText={externalDuplicate ? "This external link already exists." : null}
                                            isClickableResult={(result) => !result.invalid && !result.deprecated
                                                && !(result.inNamedGraph && Array.isArray(result.inNamedGraph))
                                                && !(result.inNamedGraph && GS.isGraphLocked(result.inNamedGraph))}
                                            title="Find a concept"
                                            onClearResults={this.declineExternal}
                                            onNoResults={this.offerExternal}
                                            lang={viewLang || defaultLang}
                                            chosen={this.includeConcept} />
                                    </div>
                                }
                            </DialogContent>
                            <DialogActions className={classes.dialogActions}>
                                <CancelButton onClick={this.exitFindConcept} />
                                {permitExternal && <PrimaryAddButton title="Add external link" disabled={!offerExternal} onClick={this.addExternal} />}
                            </DialogActions>
                        </Dialog>
                    </React.Fragment>
                )}
            </ProjectConsumer>
        );
    }
}

FindRelatedConceptDialog.defaultProps = {
    permitExternal: false,
    associatedProject: []
};

FindRelatedConceptDialog.propTypes = {
    classes: PropTypes.object,
    addTitle: PropTypes.string,
    schemeIRI: PropTypes.string.isRequired,
    source: PropTypes.string,
    components: PropTypes.array,
    linkedData: PropTypes.any,
    associatedProject: PropTypes.array,
    errorText: PropTypes.string,
    matching: PropTypes.bool,
    useWorkflow: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    exclude: PropTypes.array,
    permitExternal: PropTypes.bool,
    onIncludeConcept: PropTypes.func.isRequired
};

export default withStyles(styles)(FindRelatedConceptDialog);